import { render, staticRenderFns } from "./ParamScrollViewPage.vue?vue&type=template&id=4282e2d0"
import script from "./ParamScrollViewPage.vue?vue&type=script&lang=js"
export * from "./ParamScrollViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports